var MinHeightBoxes;
(function (MinHeightBoxes) {
    __once('edit-checkbox-first-step-a', () => {
        const mainWrapperNode = document.querySelector('#edit-checkbox-first-step-a');
        function setMinHeight() {
            let options = mainWrapperNode.querySelectorAll('.js-form-type-checkbox');
            let max_height = 0;
            const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (width >= 768) {
                options.forEach(item => {
                    let current_height = item.querySelector('.checkbox-on-wht').clientHeight;
                    max_height = current_height > max_height ? current_height : max_height;
                });
                options.forEach(item => {
                    item.querySelector('.checkbox-on-wht').querySelector('.checkbox-card-content').setAttribute('style', 'height: ' + max_height + 'px');
                });
            }
        }
        function init() {
            if (mainWrapperNode) {
                setMinHeight();
            }
        }
        init();
    });
})(MinHeightBoxes || (MinHeightBoxes = {}));
